import {createSlice} from "@reduxjs/toolkit";
import {fetchLecturersList} from "../Functions/fetchLecturersList";
import store from "storejs";

const initialState = {
    lecturers: [],
    loading: false,
    error: null,
}

export const lecturersSlice = createSlice({
    name: 'lecturers',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchLecturersList.pending, state => {
                state.loading = true
                state.error = null
            })
            .addCase(fetchLecturersList.fulfilled, (state, action) => {
                state.loading = false
                state.lecturers = action.payload.lecturers
            })
            .addCase(fetchLecturersList.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message || 'Something went wrong'
            })
    },
})

export const lecturersReducer = lecturersSlice.reducer;

export const selectLecturers = (state) => state.lecturers.lecturers||store('lecturers')||[]
export const selectLoading = (state) => state.lecturers.loading && !store('?lecturers')
export const selectError = (state) => state.lecturers.error
